import { useParams, Navigate } from 'react-router-dom';
import ServiceLandingLayout from '../components/ServiceLandingLayout';
import { integrations } from '../content/integrations';

// Data-driven integration landing page. Any published slug in
// src/content/integrations.js renders here via the shared service layout.
export default function IntegrationPage() {
  const { lang, slug } = useParams();
  const item = integrations.find((i) => i.slug === slug && i.published);

  if (!item) {
    return <Navigate to={`/${lang === 'en' ? 'en' : 'et'}/integrations`} replace />;
  }

  return (
    <ServiceLandingLayout translationKey={item.translationKey} proofLink={item.proofLink} />
  );
}
